import { extendTheme } from '@chakra-ui/react';

// Fast drawer transition theme
const theme = extendTheme({
  components: {
    Drawer: {
      baseStyle: {
        dialog: {
          transitionDuration: '60ms',
          transitionTimingFunction: 'ease-out',
        },
        overlay: {
          transitionDuration: '60ms',
          transitionTimingFunction: 'ease-out',
        }
      }
    }
  },
  // Override default transition tokens
  transition: {
    duration: {
      normal: '60ms', // Override default
    },
  }
});

export default theme;
